import React from "react"


import DXForm from "components/Form/DXForm.jsx";

class WizardView extends React.Component {
  render() {
    return (
      <DXForm
        {...this.props.location.state}
      />
    );
  }
}

export default WizardView;
